export const ADD_CUSTOMER = "ADD_CUSTOMER";
export const CUSTOMER_SUCCESS = "CUSTOMER_SUCCESS";
export const CUSTOMER_FAILED = "CUSTOMER_FAILED";
export const CUSTOMER_LOADING = "CUSTOMER_LOADING";

export const ADD_ServiceProvider = "ADD_ServiceProvider";
export const ServiceProvider_SUCCESS = "ServiceProvider_SUCCESS";
export const ServiceProvider_FAILED = "ServiceProvider_FAILED";
export const ServiceProvider_LOADING = "ServiceProvider_LOADING";

export const ADD_Booking = "ADD_Booking";
export const Booking_SUCCESS = "Booking_SUCCESS";
export const Booking_FAILED = "Booking_FAILED";
export const Booking_LOADING = "Booking_LOADING";

export const ADD_Feedback = "ADD_Feedback";
export const Feedback_SUCCESS = "Feedback_SUCCESS";
export const Feedback_FAILED = "Feedback_FAILED";
export const Feedback_LOADING = "Feedback_LOADING";

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';